export enum Language {
    Arabic,
    English,
    Spanish,
    French,
    Hindi,
    Russian,
    Japanese,
    Korean
}
